var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNext = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.89 20.0011C9.00684 20.0015 9.1226 19.9788 9.23061 19.9343C9.33863 19.8897 9.43675 19.8242 9.51933 19.7416L16.6304 12.6305C16.7959 12.4628 16.8887 12.2367 16.8887 12.0011C16.8887 11.7656 16.7959 11.5395 16.6304 11.3718L9.51933 4.26068C9.35243 4.09377 9.12605 4 8.89 4C8.65396 4 8.42758 4.09377 8.26067 4.26068C8.09376 4.42759 7.99999 4.65397 7.99999 4.89001C7.99999 5.12606 8.09376 5.35244 8.26067 5.51935L14.7567 12.0011L8.26067 18.4829C8.09521 18.6506 8.00244 18.8767 8.00244 19.1122C8.00244 19.3478 8.09521 19.5739 8.26067 19.7416C8.34325 19.8242 8.44138 19.8897 8.54939 19.9343C8.6574 19.9788 8.77316 20.0015 8.89 20.0011Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/next.db60f5fa1899182117a4fd91ed4b98f2.svg";